//export const API_URI = "http://localhost:8080/api/";
export const API_URI = "https://ra-conception.com/api/";
export const MONTHS = ["KEINER", "Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];